import React, { useState } from "react";
import { PrimaryButton, ProgressIndicator, IProgressIndicatorStyles } from "@fluentui/react";
import axios from "axios";
import styles from "./styles/cr.module.scss";
import { CrTextField } from "./components/cr/CrTextField";
import { AppGlobals } from "./AppGlobals";

interface LoginProps {
  onLoginSuccess: () => void;
}

export const Login = (props: LoginProps): React.ReactElement => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [invalidLoginMsg, setInvalidLoginMsg] = useState<string>("");
  const [progressHidden, setProgressHidden] = useState<boolean>(true);

  const handleLogin = async () => {
    try {
      setProgressHidden(false);
      setInvalidLoginMsg("");

      const coreApiUrl = process.env.REACT_APP_ZedX_Net_API!;

      const response = await axios.post(`${coreApiUrl}/Users/AuthenticateCoreUser`, {
        email,
        password
      });

      AppGlobals.UserID = response.data.Id;
      AppGlobals.UserTitle = response.data.Name;
      AppGlobals.UserEmail = response.data.Email;
      AppGlobals.CustomJwtToken = response.data.Token;

      props.onLoginSuccess();
    } catch (error) {
      console.error("Authentication error:", error);
      setInvalidLoginMsg("Invalid Email or Password.");
    } finally {
      setProgressHidden(true);
    }
  };

  const progressStyles: Partial<IProgressIndicatorStyles> = {
    itemProgress: { margin: 0, paddingTop: "3px" }
  };

  return (
    <div className="main">
      <div className="blue-banner" style={{ marginLeft: '0', paddingLeft: '0' }}>
        <div className="blue-banner-white-bold">ZedX Apps</div>
      </div>
      <div className="container">
        <div
          className="content"
          style={{ width: "100%", minWidth: 0, paddingLeft: "16px", paddingRight: "16px" }}
        >
          <div style={{ visibility: progressHidden ? "hidden" : "visible" }}>
            <ProgressIndicator barHeight={4} styles={progressStyles} />
          </div>

          <div className={styles.cr} style={{ maxWidth: 720 }}>
            <h2 style={{ color: "rgb(112,146,190)", fontWeight: "normal" }}>
              Welcome to ManageCP
            </h2>

            <p>Enter your email address and password then click login.</p>

            <div style={{ maxWidth: "500px" }}>
              <CrTextField
                label="Email Address"
                maxLength={500}
                className={styles.formField}
                value={email}
                onChange={(_, newValue) => setEmail(newValue || "")}
                required
                type="email"
              />

              <CrTextField
                label="Password"
                value={password}
                className={styles.formField}
                onChange={(_, newValue) => setPassword(newValue || "")}
                required
                type="password"
              />

              <PrimaryButton text="Login" onClick={handleLogin} />

              {invalidLoginMsg && (
                <div style={{ marginTop: 20, color: "red" }}>{invalidLoginMsg}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};